import React from "react";
import { motion } from "framer-motion";
import { BookOpen, ArrowRight } from "lucide-react";
import { DOCTRINA_PRINCIPIOS } from "../lib/content";

export const Doctrine = () => {
  return (
    <section id="doctrina" className="relative bg-white py-24 md:py-32" data-testid="doctrine-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        {/* Section header */}
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#0A2463]" />
              <span className="font-headings text-xs tracking-[0.3em] uppercase text-[#0A2463]">
                Doctrina · 10 Principios
              </span>
            </div>
            <h2 className="font-headings font-bold uppercase tracking-tight text-[#0A192F] text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              La <span className="fy-underline">arquitectura</span><br /> de la abundancia
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex flex-col items-start gap-7">
            <p className="text-lg text-[#4B5563] leading-relaxed">
              Diez principios que estructuran una reorganización integral de la vida nacional argentina.
              No son ideas sueltas: son un sistema. Una doctrina nacional, productiva, patrimonial, tecnológica y soberana.
            </p>
            <button
              type="button"
              onClick={() =>
                window.dispatchEvent(
                  new CustomEvent("openBookReader", { detail: { page: 187 } })
                )
              }
              className="group inline-flex items-center gap-3 bg-[#0A2463] hover:bg-[#0A192F] text-white font-headings uppercase tracking-wide text-sm px-7 py-4 transition-colors"
              data-testid="doctrine-read-chapter-btn"
            >
              <BookOpen size={18} className="text-[#F5B400]" />
              Nuestra Doctrina
              <ArrowRight
                size={16}
                className="group-hover:translate-x-1 transition-transform"
              />
            </button>
          </div>
        </div>

        {/* Principles grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
          {DOCTRINA_PRINCIPIOS.map((p, i) => (
            <motion.article
              key={p.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: (i % 6) * 0.05 }}
              className="group bg-white p-8 hover:bg-[#0A2463] hover:text-white transition-colors duration-300 cursor-default"
              data-testid={`doctrine-principle-${p.n}`}
            >
              <div className="flex items-start justify-between mb-6">
                <span className="font-headings text-5xl font-bold text-[#F5B400] tabular-nums leading-none">
                  {p.n}
                </span>
                <span className="font-headings text-[10px] tracking-[0.25em] uppercase text-[#9CA3AF] group-hover:text-white/60 transition-colors">
                  Principio
                </span>
              </div>
              <h3 className="font-headings text-xl font-semibold uppercase tracking-tight mb-3 leading-tight">
                {p.titulo}
              </h3>
              <p className="text-sm leading-relaxed text-[#4B5563] group-hover:text-white/80 transition-colors">
                {p.bajada}
              </p>
            </motion.article>
          ))}
        </div>

        {/* Footer quote */}
        <div className="mt-16 max-w-3xl">
          <blockquote className="border-l-4 border-[#F5B400] pl-6 py-2">
            <p className="font-headings text-xl sm:text-2xl uppercase tracking-tight text-[#0A192F] leading-snug">
              "Todo lo construido puede reconstruirse."
            </p>
            <footer className="mt-3 text-sm text-[#9CA3AF] tracking-wide">
              — Capitalismo de Abundancia
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default Doctrine;
